









































import { DiscountParams } from '@/store/interfaces/discount';
import { currencyKeyboardEventValidation } from '@/util/CurrencyValidation';
import { tCashbackParams } from '@/store/interfaces/cashback';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Amount',
  props: {
    model: {
      type: Object as PropType<DiscountParams | tCashbackParams>,
      required: true,
    },
  },
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(value: DiscountParams | tCashbackParams) {
        this.$emit('update:model', value);
      },
    },
  },
  data: () => ({
    currencyKeyboardEventValidation: currencyKeyboardEventValidation,
  }),
});
